export default __webpack_public_path__ + "static/media/Ballroll_00250.579f4e9d.png";